/** IANA time zones the browser knows, with plain "UTC" first (the browser's list leaves it out). */
export function timeZoneOptions(): string[] {
  try {
    return ['UTC', ...Intl.supportedValuesOf('timeZone').filter((z) => z !== 'UTC')];
  } catch {
    return ['UTC'];
  }
}

/** This browser's time zone, if it reports one. */
export function browserTimeZone(): string | undefined {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
}
